require("./graphic");

var _zrender = require("../zrender");

var registerPainter = _zrender.registerPainter;

var Painter = require("./Painter");

registerPainter('svg', Painter);


//////////////////
// WEBPACK FOOTER
// ./~/_zrender@3.7.4@zrender/lib/svg/svg.js
// module id = 1322
// module chunks = 0